/**
 * Gemeinsame Rechen-/Formathelfer für Tagesvorlagen (Dialog und Einsetzen-Popover).
 */

const WOCHENTAGE = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
const STANDARD_FARBE = '#2a6fdb';

/** Minuten seit Mitternacht aus "HH:mm". */
function minuten(zeit) {
	const [h, m] = zeit.split(':').map(Number);
	return h * 60 + m;
}

/** Dauer einer Schicht in Minuten; Bis vor Von = über Mitternacht (+24 h). */
function dauer(schicht) {
	if (!schicht.Von || !schicht.Bis) return 0;
	const d = minuten(schicht.Bis) - minuten(schicht.Von);
	return d <= 0 ? d + 24 * 60 : d;
}

/** Minuten als "h:mm". */
function formatStunden(min) {
	return `${Math.floor(min / 60)}:${String(min % 60).padStart(2, '0')}`;
}

/** Anzahl Schichten (Summe der Anzahlen) und Stunden (Dauer × Anzahl) einer Liste von Vorlagen-Schichten. */
function kennzahlen(schichten) {
	return schichten.reduce((summe, s) => ({
		schichten: summe.schichten + s.Anzahl,
		minuten: summe.minuten + dauer(s) * s.Anzahl,
	}), { schichten: 0, minuten: 0 });
}

function schichtenText(anzahl) {
	return `${anzahl} ${anzahl === 1 ? 'Schicht' : 'Schichten'}`;
}

/** Wochentags-Kürzel einer Liste von ISO-Wochentagen, z.B. "Fr, Sa". */
function wochentageText(wochentage) {
	return wochentage.map((tag) => WOCHENTAGE[tag - 1]).join(', ');
}

export { WOCHENTAGE, STANDARD_FARBE, minuten, dauer, formatStunden, kennzahlen, schichtenText, wochentageText };
